import _ from 'lodash';
//import isEmail from 'is-email';

function validateEmail (email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

const backend = window.backend;

export default {
  namespaced: true,

  state: {
    orderDetails: {
      name: "",
      due_at: "",
      type: "",
      purchase_order_number: "",
      tags: [],
      program: '',
      quote: null,
      auto_approve: false,
      auto_approve_amount: 500,
      uploadFileType: 'source',
    },

    uploadFiles: {
      files: [],
      filesUploading: false
    },

    selectLanguages: {
      source_language: null,
      source_language_description: null,
      target_languages: [],
      source_languages: [],
      user_language_sets: [],
      account_language_sets: [],
      user_languages: [],
    },

    deliveryOptions: {
      notify_on_order_submit: true,
      notify_on_new_comment: true,
      notify_on_quote_ready: true,
      notify_on_order_complete: true,
      emails_to_notify: [],
      connector_delivery_method: "none",
      comment: "",
    },

    onBehalf: {
      behalf_account: '',
      behalf_user: ''
    },

    queue: {
      fileRename: []
    }
  },

  mutations: {
    setOrderDetailsValue (state, payload) {
      const { value, name } = payload;

      state.orderDetails[name] = value;

      // if ( _.isEmpty(state.orderDetails[name]) ) {
      //   state.orderDetails[name] = value;
      // }
    },

    setSourceLanguage (state, value) {
      state.selectLanguages.source_language = value;
    },

    setSourceLanguageDescription (state, value) {
      state.selectLanguages.source_language_description = value;
    },

    setDeliveryOption (state, payload) {
      let { option, value } = payload;

      state.deliveryOptions[option] = value;
    },

    setConnectorDeliveryMethod (state, value) {
      state.deliveryOptions.connector_delivery_method = value;
    },

    setTargetLanguages (state, value) {
      state.selectLanguages.target_languages = value;
    },

    setOrderName (state, value) {
      state.orderDetails.name = value;
    },

    setFiles (state, value) {
      state.uploadFiles.files = value;
    },

    setBehalfAccount (state, value) {
      state.onBehalf.behalf_account = value;
    },

    setBehalfUser (state, value) {
      state.onBehalf.behalf_user = value;
    },

    setUploadFileType (state, fileType) {
      state.orderDetails.uploadFileType = fileType;
    },

    setUploadFiles (state, files) {
      state.uploadFiles.files = files;
    },

    setComment (state, comment) {
      state.deliveryOptions.comment = comment;
    },

    setFilesUploading (state, value) {
      state.uploadFiles.filesUploading = value;
    },

    addNotifyEmail (state, value) {
      state.deliveryOptions.emails_to_notify.push(value);
    },

    addFileRename (state, value) {
      state.queue.fileRename.push(value);
    },

    setUserLanguageSet (state, value) {
      state.selectLanguages.user_language_sets = value;
    },

    setAccountLanguageSets (state, value) {
      state.selectLanguages.account_language_sets = value;
    },

    setSourceLanguages (state, value) {
      state.selectLanguages.source_languages = value;
    },

    setUserLanguages (state, value) {
      state.selectLanguages.user_languages = value;
    }
  },

  actions: {
    updateOrderName ({state, commit, getters, rootGetters}, value) {
      commit('setOrderName', value);
    },

    updateFiles ({state, commit, getters, rootGetters}, value) {
      commit('setFiles', value);
    },

    updateOrderDetailsValue ({state, commit, getters, rootGetters}, payload) {
      commit('setOrderDetailsValue', payload);
    },

    updateSourceLanguage({state, commit, getters, rootGetters}, value) {
      commit('setSourceLanguage', value);
    },

    updateSourceLanguageDescription({state, commit, getters, rootGetters}, value) {
      commit('setSourceLanguageDescription', value);
    },

    updateDeliveryOption ({state, commit, getters, rootGetters}, payload) {
      commit('setDeliveryOption', payload);
    },

    updateConnectorDeliveryMethod ({state, commit, getters, rootGetters}, value) {
      commit('setConnectorDeliveryMethod', value)
    },

    updateTargetLanguages ({state, commit, getters, rootGetters}, value) {
      commit('setTargetLanguages', value);
    },

    updatecomment ({state, commit, getters, rootGetters}, value) {
      commit('setComment', value);
    },

    pushRenamedFileToQueue ({state, commit, getters, rootGetters}, value) {
      commit('setFileRenameQueue', value);
    },

    /**
     * When a user enters an email to notify
     *
     */
     onNotifyEmail ({state, commit, getters, rootGetters}, value) {
        if (validateEmail(value)) {
          commit('addNotifyEmail', value);
        }
    },

    getUserLanguageSets ({state, commit, getters, rootGetters}, userId) {
      let sourceLanguage = state.selectLanguages.source_language;

      return axios
        .get(`/languages/sets/${userId}/source/${sourceLanguage}`)
        .then(result => {
          const {data} = result.data;

          commit('setUserLanguageSet', data)

          return data;
        });
    },

    getAccountLanguageSets ({state, commit, getters, rootGetters}, id) {
      let sourceLanguage = state.selectLanguages.source_language;

      return axios
        .get(`/languages/sets/accounts/${id}/source/${sourceLanguage}`)
        .then(result => {
          const {data} = result.data;

          commit('setAccountLanguageSets', data);

          return data;
        });
    },

    /**
     * Get all users available languages
     *
     */
    getTargetLanguages ({state, commit, getters, rootGetters}, id) {
      let sourceLanguage = state.selectLanguages.source_language;

      return axios(`/languages/all/${sourceLanguage}`)
        .then(result => {
          const {data} = result;

          commit('setUserLanguages', data)

          //@TODO - Rename this to make more clear
          return data;
        });
    },

    /**
     * Load the users source langauges
     *
     */
    getSourceLanguages ({state, commit, getters, rootGetters}, value) {
      return axios(`/languages/sources`)
        .then(result => {
          const {data} = result.data;
          commit('setSourceLanguages', data)

          //@TODO - Rename this to make more clear
          return data;
        });
    },

    /**
     * Get dropdown/select options values for
     * Order details
     *
     */
    getDefaultOrderDetailsOptions () {
      return axios
        .get('/create-order/order-details/options')
        .then((result) => result.data);
    },

    /**
     * Get account order types
     * Order details
     *
     */
    getAccountOrderTypes ({state, commit, getters, rootGetters}, accountId) {
      return axios
        .get(`/create-order/account/${accountId}/order-types`)
        .then((result) => result.data);
    },

    /**
     * get email automations for this account
     *
     * @return void
     */
    getEmailAutomations ({state, commit, getters, rootGetters}, accountId) {
      return axios
        .get(`/create-order/account/${accountId}/automated-emails`)
        .then(result => result.data)
    },

    /**
     * get the set preference for automated emails
     *
     * @return void
     */
    getAutomatedEmailsEnabled ({state, commit, getters, rootGetters}, accountId) {
      return axios
        .get(`/create-order/account/${accountId}/automated-emails-enabled`)
        .then(result => result.data)
    },

    /**
     * set the preference for automated emails
     *
     * @return void
     */
    setAutomatedEmailsEnabled ({state, commit, getters, rootGetters}, {accountId, isEnabled}) {
      return axios
        .post(`/admin/account/${accountId}/automated-emails-enabled`, {isEnabled})
        .then(result => result.data)
    },
  },

  getters: {
    orderType: state => {
      return state.orderDetails.type;
    },

    filesUploading: state => {
      return state.uploadFiles.filesUploading;
    },

    uploadedFiles: state => {
      return state.uploadFiles.files;
    },

    behalf_account: state => {
      return state.onBehalf.behalf_account;
    },

    behalf_user: state => {
      return state.onBehalf.behalf_user;
    },

    fileRenameQueue: state => {
      return state.queue.fileRename;
    },

    deliveryOptionComment: state => {
      return state.deliveryOptions.comment;
    },

    userLanguageSets: state => {
      return state.selectLanguages.user_language_sets;
    },

    userLanguages: state => {
      return state.selectLanguages.user_languages;
    },

    sourceLanguages: state => {
      return state.selectLanguages.source_languages;
    },

    accountLanguageSets: state => {
      return state.selectLanguages.account_language_sets;
    },

    accountTargetLanguages: state => {
      return state.selectLanguages.target_languages;
    }
  }
};
